import logo from './Ritmo-logo.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="coming-soon">
          <img src={logo} className="App-logo" alt="logo" />
          <h1>Coming Soon</h1>
          <p>We're working hard to bring you something awesome!</p>
        </div>
      </header>
    </div>
  );
}

export default App;
